var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankActiveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 2.25C11.8301 2.25 11.6601 2.29 11.5101 2.37L3.51006 6.37C3.12006 6.56 2.87006 6.95 2.87006 7.39C2.87006 8.04 3.40006 8.57 4.05006 8.57H19.9501C20.6001 8.57 21.1301 8.04 21.1301 7.39C21.1301 6.95 20.8801 6.56 20.4901 6.37L12.4901 2.37C12.3401 2.29 12.1701 2.25 12.0001 2.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 20.75H3.25C2.84 20.75 2.5 20.41 2.5 20C2.5 19.59 2.84 19.25 3.25 19.25H20.75C21.16 19.25 21.5 19.59 21.5 20C21.5 20.41 21.16 20.75 20.75 20.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 19.25H4.75C4.34 19.25 4 18.91 4 18.5V10C4 9.59 4.34 9.25 4.75 9.25H19.25C19.66 9.25 20 9.59 20 10V18.5C20 18.91 19.66 19.25 19.25 19.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 17.75C8.84 17.75 8.5 17.41 8.5 17V11.5C8.5 11.09 8.84 10.75 9.25 10.75C9.66 10.75 10 11.09 10 11.5V17C10 17.41 9.66 17.75 9.25 17.75Z",
    fill: "#4a4a4a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.75C11.59 17.75 11.25 17.41 11.25 17V11.5C11.25 11.09 11.59 10.75 12 10.75C12.41 10.75 12.75 11.09 12.75 11.5V17C12.75 17.41 12.41 17.75 12 17.75Z",
    fill: "#4a4a4a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 17.75C14.34 17.75 14 17.41 14 17V11.5C14 11.09 14.34 10.75 14.75 10.75C15.16 10.75 15.5 11.09 15.5 11.5V17C15.5 17.41 15.16 17.75 14.75 17.75Z",
    fill: "#4a4a4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankActiveIcon);
export default __webpack_public_path__ + "static/media/bank-active-icon.fdd4021efc9f2288950ab31f0f8717df.svg";
export { ForwardRef as ReactComponent };